__turbopack_context__.v({
  "container": "EventSessionCard-module__K5LlqW__container",
  "participant": "EventSessionCard-module__K5LlqW__participant",
  "participantLink": "EventSessionCard-module__K5LlqW__participantLink",
  "participants": "EventSessionCard-module__K5LlqW__participants",
  "sessionData": "EventSessionCard-module__K5LlqW__sessionData",
});
